import { render } from "./UsersList.vue?vue&type=template&id=5488ff28"
import script from "./UsersList.vue?vue&type=script&lang=js"
export * from "./UsersList.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__